import { useEffect } from 'react'
import { PRERENDER } from './prerender'

// RÉVÉLATION AU DÉFILEMENT.
//
// Les cibles portent la classe `lp-rv` dans le JSX. Au prérendu, rien n'est
// caché : le HTML figé doit contenir chaque section visible, c'est lui que
// Google lit. La chorégraphie reprend à l'hydratation, dans un vrai
// navigateur. L'état masqué n'est posé par le CSS que si la page porte
// `lp-js` : sans script, rien n'est jamais caché.
export default function useReveal (ref) {
  useEffect(() => {
    const root = ref.current
    if (!root || !('IntersectionObserver' in window)) return
    if (PRERENDER) return
    if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return

    root.classList.add('lp-js')

    // Cascade : au sein d'un même parent, les frères révélés sont numérotés
    // dans l'ordre du DOM. Le CSS lit --i pour espacer les entrées.
    root.querySelectorAll('.lp-rv').forEach(el => {
      const sibs = [...el.parentNode.children].filter(c => c.classList.contains('lp-rv'))
      if (sibs.length > 1) el.style.setProperty('--i', sibs.indexOf(el))
    })

    const io = new IntersectionObserver(entries => {
      for (const e of entries) {
        if (!e.isIntersecting) continue
        e.target.classList.add('lp-rv--in')
        io.unobserve(e.target)
      }
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 })

    root.querySelectorAll('.lp-rv').forEach(el => io.observe(el))
    return () => io.disconnect()
  }, [ref])
}
